/* RevealLine: grows from no height, the thread's gap above it included, and fades in.
   The host sets --reveal-gap (its thread's gap between entries) and --reveal-margin (the line's
   resting margin under the bubble). */
.reveal {
  display: grid;
  grid-template-rows: 1fr;
  margin-top: var(--reveal-margin, 0px);
  animation: reveal-line 0.28s cubic-bezier(0.32, 0.72, 0, 1) both;
}

.clip {
  min-height: 0;
  overflow: hidden;
  display: flex;
  justify-content: flex-end;
}

@keyframes reveal-line {
  from {
    grid-template-rows: 0fr;
    margin-top: calc(-1 * var(--reveal-gap, 8px));
    opacity: 0;
  }
  to {
    grid-template-rows: 1fr;
    margin-top: var(--reveal-margin, 0px);
    opacity: 1;
  }
}

@media (prefers-reduced-motion: reduce) {
  .reveal { animation: none; }
}
